module.exports = __webpack_public_path__ + "static/img/pp-01.b2d71a6f.jpg";